"use client";

import { useState } from "react";

function EnviarAlmacen({ onClose, onSubmit, userRole, solicitud }) {
  // Solo almacén puede responder
  const isAlmacenView = userRole === "almacen" && !!solicitud;
  const isAlmacenResponse =
    isAlmacenView && (solicitud?.status || "").toLowerCase() === "pending";

  const safeResponseAttachments = Array.isArray(
    solicitud?.response_attachments
  )
    ? solicitud.response_attachments
    : [];

  const [estado, setEstado] = useState("");
  const [archivoRespuesta, setArchivoRespuesta] = useState(null);
  const [motivoRechazo, setMotivoRechazo] = useState("");
  const [loading, setLoading] = useState(false);

 const handleEnviar = async () => {
  // Validaciones antes de enviar
  if (!estado) {
    alert("Debe seleccionar el estado de la solicitud");
    return;
  }

  if (estado === "negado" && !motivoRechazo.trim()) {
    alert("Debe ingresar el motivo del rechazo");
    return;
  }

  if (!solicitud?.id) {
    alert("No se encontró el identificador de la solicitud");
    return;
  }

  setLoading(true);
  try {
    await onSubmit({
      requestId: solicitud.id,
      response_status: estado,                     
      status: estado,                             
      motivoRechazo: motivoRechazo || null,
      response_attachments: archivoRespuesta ? [archivoRespuesta] : [],
    });

    // ✅ si onSubmit no lanza error, consideramos que todo salió bien
    alert("Respuesta enviada correctamente.");
    onClose?.();           // cerrar modal de respuesta
  } catch (error) {
    console.error("Error al responder almacén:", error);
    alert("Error al responder: " + (error.message || "Error desconocido"));
  } finally {
    setLoading(false);
  }
};

  if (!isAlmacenView) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "2rem",
          borderRadius: "10px",
          width: "500px",
          maxHeight: "80vh",
          overflowY: "auto",
          boxShadow: "0 0 10px rgba(0,0,0,0.2)",
        }}
      >
        <h3>Responder solicitud de almacén</h3>

        <p style={{ fontSize: "0.9rem", color: "#555" }}>
          <strong>Radicado:</strong> {solicitud.radicado || "Sin radicado"}
          <br />
          <strong>Secretaría:</strong> {solicitud.secretaria || "N/A"}
          <br />
          <strong>Objeto contractual:</strong>{" "}
          {solicitud.objetoContractual || "N/A"}
        </p>

        <div style={{ marginBottom: "1rem" }}>
          <label>
            <strong>Estado de la solicitud *</strong>
          </label>
          <br />
          <div style={{ marginTop: "0.5rem", display: "flex", gap: "2rem" }}>
            <label
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <input
                type="radio"
                name="estadoAlmacen"
                value="aprobado"
                checked={estado === "aprobado"}
                onChange={(e) => setEstado(e.target.value)}
                style={{ accentColor: "#28a745" }}
              />
              Aprobado
            </label>
            <label
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <input
                type="radio"
                name="estadoAlmacen"
                value="negado"
                checked={estado === "negado"}
                onChange={(e) => setEstado(e.target.value)}
                style={{ accentColor: "#dc3545" }}
              />
              Negado
            </label>
          </div>
        </div>

        {estado === "negado" && (
          <div style={{ marginBottom: "1rem" }}>
            <label>
              <strong>Motivo del rechazo *</strong>
            </label>
            <br />
            <textarea
              value={motivoRechazo}
              onChange={(e) => setMotivoRechazo(e.target.value)}
              placeholder="Ingrese el motivo del rechazo..."
              style={{
                width: "100%",
                minHeight: "80px",
                padding: "0.5rem",
                border: "1px solid #ccc",
                borderRadius: "4px",
                resize: "vertical",
                marginTop: "0.5rem",
              }}
            />
          </div>
        )}

        <div style={{ marginBottom: "1rem" }}>
          <label>
            <strong>Adjuntar certificado / PDF de respuesta (opcional)</strong>
          </label>
          <br />
          <input
            type="file"
            accept=".pdf,.doc,.docx"
            onChange={(e) => setArchivoRespuesta(e.target.files[0])}
          />
        </div>

        {/* Mostrar respuesta previa si ya existe */}
        {safeResponseAttachments.length > 0 && (
          <div
            style={{
              marginBottom: "1rem",
              padding: "0.75rem",
              backgroundColor: "#f3f4f6",
              borderRadius: "4px",
            }}
          >
            <strong>Respuesta registrada:</strong>
            <div style={{ marginTop: "0.25rem" }}>
              {safeResponseAttachments.map((file, idx) => (
                <div key={idx}>
                  <a
                    href={file.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#007bff", textDecoration: "underline" }}
                  >
                    {file.name}
                  </a>
                </div>
              ))}
            </div>
          </div>
        )}

        <div
          style={{
            marginTop: "1.5rem",
            display: "flex",
            justifyContent: "flex-end",
            gap: "0.5rem",
          }}
        >
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: "0.5rem 1rem",
              borderRadius: "4px",
              border: "1px solid #ccc",
              backgroundColor: "#f3f4f6",
              cursor: "pointer",
            }}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={handleEnviar}
            style={{
              padding: "0.5rem 1rem",
              borderRadius: "4px",
              border: "none",
              backgroundColor: "#16a34a",
              color: "#fff",
              cursor: "pointer",
            }}
            disabled={loading}
          >
            {loading ? "Enviando..." : "Enviar respuesta"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EnviarAlmacen;
